exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32720657","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./static/js/Order/components/ResultsSummary.vue
// module id = 748
// module chunks = 0